import { useNavigate } from '@tanstack/react-router';
import { MailCheck } from 'lucide-react';
import { Button } from '@new/common/ui';

const ConfirmEmail = () => {
  const navigate = useNavigate();

  return (
    <section className="flex w-full max-w-md md:max-w-lg lg:max-w-xl flex-col gap-6 items-center text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-(--primary-O200)">
        <MailCheck size={32} className="text-(--primary-O900)" />
      </div>

      <h1 className="[font-size:var(--fs-h3)]! md:[font-size:var(--fs-h2)]! xl:[font-size:var(--fs-h1)]! text-(--neutral-black-NB1000)! m-0! leading-tight">
        Please confirm your email
      </h1>

      <p className="[font-size:var(--fs-p4)]! lg:[font-size:var(--fs-p3)]! text-(--neutral-black-NB700)! m-0!">
        We&apos;ve sent a confirmation link to your email address. Please open the email and click
        the link to verify your account. Once your email is confirmed, you can log in with your
        credentials.
      </p>

      <Button variant="primary" onClick={() => navigate({ to: '/login' })}>
        Go to Login
      </Button>
    </section>
  );
};

const Page = () => {
  return (
    <div className="flex min-h-screen items-center justify-center p-5.25 md:p-10 xl:pr-24.75 ">
      <ConfirmEmail />
    </div>
  );
};

export default Page;
